/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import {
  intlShape,
  backendShape,
  browserShape,
  notifierShape,
  withBackend,
  withBrowser,
  withNotifier,
  NotFoundError,
  Select,
  ActionBar,
  isEmpty,
  Container,
  Column,
  Heading,
  Loader,
  Row,
  withConfiguration,
} from "lcm-iot-commons";
import PaidPlan from "lcm-iot-commons/client/lib/components/UpgradePlan/PaidPlan";
import UnavailablePlan from "lcm-iot-commons/client/lib/components/UpgradePlan/UnavailablePlan";

type Props = {
  backend: backendShape;
  browser: browserShape;
  intl: intlShape;
  notifier: notifierShape;
  match: {
    params?: {
      id?: string;
    };
  };
  configuration: {
    defaultCurrency?: string;
    language?: string;
  };
};

export function PlanVariantSelectionUpgrade({
  backend,
  browser,
  intl,
  notifier,
  match,
  configuration,
}: Props) {
  const [upgradeState, setUpgradeState] = useState({
    planVariants: undefined,
    planCart: undefined,
    subscription: undefined,
    currencies: undefined,
    currency: undefined,
    loading: true,
  });
  const [creatPlanCart, setCreatPlanCart] = useState({
    creating: false,
    selectedPlanVariantId: undefined,
  });
  const { defaultCurrency } = configuration;

  const loadCurrencies = async () => {
    const response = await backend.get("/plan_variants/currencies");
    return response.currencies.map((planCurrency: $TSFixMe) => ({
      id: planCurrency.code,
      name: planCurrency.code,
      selected: planCurrency.selected,
    }));
  };

  const loadData = async (actualCurrency: $TSFixMe) => {
    try {
      let nextCurrency;
      let planCart;
      const nextCurrencies =
        upgradeState.currencies || (await loadCurrencies());
      const subscription = await backend.get(
        `/subscriptions/${
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          match.params.id
        }`,
        { include: "payment_details" },
      );

      const filter = { language: configuration.language };
      if (subscription.plan_variant.endsWith("-usd")) {
        nextCurrency =
          actualCurrency ||
          nextCurrencies.find((c: $TSFixMe) => c.id === "USD");
        (filter as $TSFixMe).currency = nextCurrency.id;
      } else if (
        subscription.type === "free" &&
        subscription.plan_variant.endsWith("-free")
      ) {
        nextCurrency =
          actualCurrency ||
          nextCurrencies.find((c: $TSFixMe) => c.id === defaultCurrency);
        (filter as $TSFixMe).currency = nextCurrency.id;
      } else {
        nextCurrency =
          actualCurrency || nextCurrencies.find((c: $TSFixMe) => c.selected);
        (filter as $TSFixMe).current_id = subscription.plan_variant;
      }

      const responsePlanVariants = await backend.get("/plan_variants", filter);
      try {
        planCart = await backend.get("/plan_cart", {
          language: configuration.language,
        });
      } catch (error) {
        if (!(error instanceof NotFoundError)) {
          notifier.showError(backend.translateError(error));
        }
      }
      setUpgradeState({
        planVariants: responsePlanVariants.plan_variants,
        planCart,
        subscription,
        currencies: nextCurrencies,
        currency: nextCurrency,
        loading: false,
      });
    } catch (error) {
      if (error instanceof NotFoundError) {
        browser.navigateTo("/404");
      } else {
        notifier.showError(backend.translateError(error));
      }
    }
  };

  React.useEffect(() => {
    // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
    loadData();
  }, []);

  const handleOnSelect = async (
    planVariant: $TSFixMe,
    planVariantAddons: $TSFixMe,
  ) => {
    setCreatPlanCart({ creating: true, selectedPlanVariantId: planVariant.id });
    try {
      const packedPlanCart = {
        plan_variant_id: planVariant.id,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        subscription_id: match.params.id,
        addons: planVariantAddons
          ? Object.keys(planVariantAddons).map((addonId) => ({
              plan_variant_addon_id: addonId,
              amount: planVariantAddons[addonId],
            }))
          : null,
      };
      await backend.post(
        "/plan_cart",
        { language: configuration.language },
        packedPlanCart,
      );
      if (
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        upgradeState.subscription.type === "free" &&
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        isEmpty(upgradeState.subscription.addons)
      ) {
        browser.navigateTo("/subscription/create");
      } else {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        browser.navigateTo(`/subscription/connect/${match.params.id}/checkout`);
      }
    } catch (error) {
      notifier.showError(backend.translateError(error));
    }
  };

  const renderPlanVariant = (planVariant: $TSFixMe) => {
    const { planVariants, subscription, planCart } = upgradeState;
    const { creating, selectedPlanVariantId } = creatPlanCart;
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const isFree = subscription.type === "free" && isEmpty(subscription.addons);
    const fullCurrentVariant = isFree
      ? // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        planVariants.find((plan: $TSFixMe) => plan.type === "free")
      : // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        planVariants.find(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          (plan: $TSFixMe) => plan.id === subscription.plan_variant,
        );
    let displayPlanVariant = null;

    if (
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      subscription.plan_variant === planVariant.id ||
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      (isFree && subscription.type === planVariant.type)
    ) {
      displayPlanVariant = (
        <PaidPlan
          mode="current"
          planCart={planCart}
          planVariant={planVariant}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          currentAddons={subscription.addons}
          currentPlanVariant={fullCurrentVariant}
          onSelect={handleOnSelect}
          disabled={creating}
          creating={selectedPlanVariantId === planVariant.id}
        />
      );
    } else if (fullCurrentVariant.sort > planVariant.sort) {
      displayPlanVariant = <UnavailablePlan planVariant={planVariant} />;
    } else {
      displayPlanVariant = (
        <PaidPlan
          mode="upgrade"
          planCart={planCart}
          planVariant={planVariant}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          currentAddons={subscription.addons}
          currentPlanVariant={fullCurrentVariant}
          onSelect={handleOnSelect}
          disabled={creating}
          creating={selectedPlanVariantId === planVariant.id}
        />
      );
    }

    return (
      <div
        id={planVariant.id}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        className={`col-md-${12 / upgradeState.planVariants.length}`}
        key={planVariant.id}
      >
        {displayPlanVariant}
      </div>
    );
  };

  const renderPlanVariants = () => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const chargeBeePlanVariants = upgradeState.planVariants.map(
      (pv: $TSFixMe) => renderPlanVariant(pv),
    );
    return chargeBeePlanVariants;
  };

  // eslint-disable-next-line camelcase
  const planVariants =
    upgradeState?.planVariants &&
    (upgradeState?.subscription as $TSFixMe)?.plan_variant
      ? renderPlanVariants()
      : null;

  const renderCurrencySelection =
    (upgradeState?.subscription as $TSFixMe)?.type === "free" &&
    isEmpty((upgradeState?.subscription as $TSFixMe)?.addons) ? (
      <div className="action-bar">
        <div id="currency-select" className="form-group">
          <label>{intl.formatMessage({ id: "planvariant.currency" })}</label>
          <Select
            options={upgradeState.currencies}
            selectedOption={upgradeState.currency}
            onChange={loadData}
          />
        </div>
      </div>
    ) : null;

  return (
    <Loader loading={upgradeState.loading}>
      <Container id="connect-plan-variants" className="container plan-variants">
        <Row>
          <Column className="col-xs-12">
            <ActionBar>
              <Heading
                title={intl.formatMessage({ id: "plan_variants.title" })}
              />
              {renderCurrencySelection}
            </ActionBar>
          </Column>
        </Row>
        <Row>
          <div id="plan-variants-items">{planVariants}</div>
        </Row>
      </Container>
    </Loader>
  );
}

export default injectIntl(
  withBackend(
    withBrowser(withNotifier(withConfiguration(PlanVariantSelectionUpgrade))),
  ),
);
